import { AppContext } from 'context/appContext'
import { PANEL_URL } from 'utils/constants'
import { useContext } from 'react'

export function useSkip(): { handleOnSkip: any } {
  const { updateCurrentCompanyReference, wizardData } = useContext(AppContext)
  function handleOnSkip() {
    return async () => {
      await updateCurrentCompanyReference(wizardData.idReferenceCompany)
      //@fyi: can't use history.push because needs to reload user data
      window.location.replace(PANEL_URL.DASHBOARD)
    }
  }
  return {
    handleOnSkip
  }
}
